//Library importsd
import styled from "styled-components";
import { useState } from "react";
import { Popover } from "antd";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";
import { RootState } from "store";

//Local imports
import { ReactComponent as Triangle } from "../../../assets/img/icons/Triangle.svg";
import { ReactComponent as Diamond } from "../../../assets/img/icons/Diamond.svg";
import PopoverContent from "../Reminders/AssetPopoverData";
import { ASSET_TYPE } from "../../../constants/index";
import Button from "modules/Common/Components/Button";
import { IVersion } from "../interfaces";
import { IDS_CAMPAIGNS } from "constants/onBoardingIds";
import { getAssetReminder } from "../Emails/actions";

interface ITextContainerProps {
  color?: string;
  width: string;
  height: string;
  borderRadius: string;
  useGradient?: boolean;
  paddingLeft?: string;
  smHeight?: string;
}

interface IPalletButtonSection {
  greenText?: String;
  dateText?: String;
  renderItem?: Function;
  disableGraphAndStats?: boolean;
  data?: any;
  assetType?: String;
}

const PalletButtonSection = (props: IPalletButtonSection) => {
  var currentUrl = window.location.href;
  const sentEditions: IVersion[] = useSelector((state: RootState) => state.assetDetails.sentEditions);
  const draftEditions: IVersion[] = useSelector((state: RootState) => state.assetDetails.draftEditions);

  let version_id = 0;
  let status: any = "";
  if (draftEditions.length > 0) {
    version_id = draftEditions[0].version_id;
    status = draftEditions[0].status;
  } else if (sentEditions.length > 0) {
    version_id = sentEditions[0].version_id;
    status = sentEditions[0].status;
  }
  const percentage = (num: any, den: any) => {
    return Math.floor((num / den) * 100);
  };

  const [isVisible, setIsVisible] = useState(false);

  const editClickHandler = () => {
    const urlParams = new URLSearchParams(currentUrl);
    const assetId = urlParams.get("asset_id");
    if (assetId) {
      getAssetReminder(assetId);
    }
    setIsVisible(true);
  };

  const cancelClickHandler = () => {
    setIsVisible(false);
  };
  const saveReminderClickHandler = () => {
    setIsVisible(false);
  };

  const onVisibleChange = () => {
    setIsVisible(!isVisible);
  };
  const history = useHistory();

  return (
    <PalletButtonSectionWrapper>
      {props.assetType === ASSET_TYPE.CUSTOM && status !== "Sent" ? (
        <Button
          value="Publish now"
          onClick={() => {
            history.push("/campaigns/editionedit/publish/" + window.location.search + "&version_id=" + version_id);
          }}
        />
      ) : history.location.pathname.startsWith("/campaigns/content/asset") && status !== "Sent" ? (
        <>
          <div className="text-margin">
            <div className="text-styling">Publish reminders</div>
            <Popover
              // offset-x | offset-y | blur-radius | spread-radius | color
              // box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2);
              overlayInnerStyle={{
                borderRadius: 15,
                width: "27.5em",
                boxShadow: "0 2px 60px 0 rgba(0, 0, 0, 0.28)",
              }}
              placement="bottomRight"
              content={
                <PopoverContent
                  cancelClickHandler={cancelClickHandler}
                  saveReminderClickHandler={saveReminderClickHandler}
                />
              }
              trigger="click"
              visible={isVisible}
              onVisibleChange={onVisibleChange}
            >
              <div onClick={editClickHandler} className="text-styling-green clickable">
                {props.greenText}
              </div>
            </Popover>
          </div>

          <div className="text-styling-2">{props.dateText}</div>
        </>
      ) : (
        ""
      )}
      {!props?.disableGraphAndStats && (
        <div id={IDS_CAMPAIGNS.OVERALL_ENGAGEMENT} className="d-flex flex-column pellete-section">
          {props.renderItem && <div className="engagement-chart">{props.renderItem()}</div>}
          <div className="d-flex flex-row inner-pellete-section">
            <TextContainer color="#FF9531" width="50%" height="180px" borderRadius="10px">
              <div className="d-flex flex-column stats-container">
                <div className="d-flex flex-row align-items-center stat-type-container">
                  {<Triangle className="icon-styling" />}
                  <span className="stat-type">Opens</span>
                </div>
                <div className="stats-data">
                  <span className="stats">{props?.data?.total_opens || "NA"}</span>
                </div>
                <div className="d-flex justify-content-center">
                  <span className="percentage">
                    {`${
                      percentage(props?.data?.total_opens ?? 0, props?.data?.total_sent ?? 1) || "NA"
                    }% Open rate`}
                  </span>
                </div>
              </div>
            </TextContainer>
            <TextContainer color="#27CE0A" width="50%" height="180px" borderRadius="10px">
              <div className="d-flex flex-column stats-container">
                <div className="d-flex flex-row align-items-center stat-type-container">
                  {<Diamond className="icon-styling" />}
                  <span className="stat-type">Clicks</span>
                </div>
                <div className="stats-data">
                  <span className="stats">{props?.data?.total_clicks || "NA"}</span>
                </div>
                <div className="d-flex justify-content-center">
                  <span className="percentage">
                    {`${
                      percentage(props?.data?.total_clicks ?? 0, props?.data?.total_sent ?? 1) || `NA`
                    }% Click rate`}
                  </span>
                </div>
              </div>
            </TextContainer>
          </div>
        </div>
      )}
    </PalletButtonSectionWrapper>
  );
};

export default PalletButtonSection;

const PalletButtonSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 74px;
  button {
    margin: 0 auto;
  }
  .flex-none {
    display: inline-block;
  }
  .description-number {
    text-align: center;
    color: #ffffff;
    font-size: 50px;
    font-family: "Roboto Slab", serif;
  }
  .description-text {
    color: #ffffffbf;
    font-size: 14px;
    font-family: "Roboto Slab", serif;
  }
  .icon-styling {
    margin-right: 0.25em;
  }
  .clickable {
    cursor: pointer;
  }
  .text-margin {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    margin-top: 4.5em;
  }
  .text-styling {
    color: #424b50;
    font-size: 20px;
    font-family: "Roboto Slab", serif;
    font-weight: 500;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 14px;
    }
  }
  .text-styling-green {
    color: #27ce0a;
    font-family: "robotoregular";
    font-size: 16px;
    font-weight: 700;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 12px;
    }
  }
  .text-styling-2 {
    margin: 1em 0 -3em 3.5em;
    color: #5e7079;
    font-family: "robotoregular";
    font-size: 14px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      margin: 6px 0 0em 3.5em;
      font-size: 10px;
    }
  }
  .pellete-section {
    margin-left: -42px;
    margin-top: 73px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      margin-left: -10px;
    }
  }
  .inner-pellete-section {
    margin-top: 22px;
  }
  .inner-pellete-section > :nth-child(2) {
    margin-left: 22px;
    margin-right: 15px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      margin-left: 15px;
      margin-right: 15px;
    }
  }
  .engagement-chart {
    margin-bottom: 10px;
    margin-right: 15px;
    height: 200px;
    margin-top: -5px;
    @media all and (max-width: 1439px) {
      height: 180px;
      margin-top: -15px;
    }
    canvas {
      max-height: 200px;
    }
    /* @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      max-width: 265px;
    } */
  }
`;

export const TextContainer = styled("div")<ITextContainerProps>`
  background: ${(props) => props.color};
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  border-radius: ${(props) => props.borderRadius};
  padding-left: ${(props) => props.paddingLeft};
  ${(props) =>
    props.useGradient &&
    `
    background:linear-gradient(#4B79D7,#001760) ;
    `}

  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    max-width: 50%;
    height: 165px;
    border-radius: 7px;
  }
  @media all and (max-width: 1439px) {
    height: 120px;
  }
  .heading {
    margin: 0px;
    display: inline-block;
    font-weight: 400;
    font-size: 18px;
    line-height: 20px;
    color: #ffffff;
    font-family: "Roboto Slab", serif;
    padding-left: 20px;
    padding-top: 18px;
  }
  .description {
    display: inline-block;
    margin-top: 27px;
    font-family: "robotoregular";
    font-weight: 300;
    font-size: 18px;
    line-height: 22px;
    color: #ffffff;
    opacity: 54%;
    height: 112px;
    text-align: center;
  }
  .stats-container {
    justify-content: space-between;
    padding: 18px 0;
    height: 100%;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      padding: 12px 0;
    }
    span {
      color: white;
    }
    .stats {
      font-size: 55px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 40px;
        line-height: 36px;
      }
    }
    .percentage {
      opacity: 0.75;
      font-size: 14px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 13px;
      }
    }
    .stat-type {
      font-size: 20px;
      padding-left: 8px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 14px;
        padding-left: 5px;
      }
    }
    .stats-data {
      display: flex;
      flex-direction: column;
      align-items: center;
      height: calc(100% - 20px);
      justify-content: space-around;
    }
    .stat-type-container {
      padding-left: 15px;
    }
  }
`;
